module.exports = __webpack_public_path__ + "static/media/hero-small-subscribed.5211aaf5.jpg";